import bg2 from "../../assets/experts/bg-2.png";
import TouristVisaSlider from "./TouristVisaSlider";
import { Visa } from "../../types/homeComponentTypes";
import { Section4 } from "../../types/home";

interface Props {
  visitOffers: Visa[];
  section4?: Section4;
}

const TouristVisa: React.FC<Props> = ({ visitOffers, section4 }) => {
  return (
    <section className="touristVisa bg-2 py-5">
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6">
            <div
              className="hd-style-2  wow animate__fadeInLeft "
              data-wow-duration="1.5s"
              data-wow-delay=".5s"
            >
              <h2
                dangerouslySetInnerHTML={{
                  __html: section4?.heading ?? "",
                }}
                aria-label="headings"
              ></h2>
              <p
                dangerouslySetInnerHTML={{
                  __html: section4?.line ?? "",
                }}
              ></p>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="position-relative">
              <img
                loading="lazy"
                src={bg2}
                alt="no img"
                className="img-fluid wow animate__zoomIn"
              />
              <span className="position-absolute visually-hidden ">
                Experience hassle-free visa solutions, backed by over a decade
                of excellence in the UAE. From swift tourist visas to flexible
                extensions, we provide trusted and tailored services for all
                your travel needs. Choose ease, reliability, and expertise—book
                with us today!
              </span>
            </div>
          </div>
        </div>

        <div className="row">
          <TouristVisaSlider visaData={visitOffers} />
        </div>
      </div>
    </section>
  );
};

export default TouristVisa;
